import DeliveryInfoCard from "./DeliveryInfoCard";
import NoteCard from "./NoteCard";
import DeliveryHeader from "./DeliveryHeader";
import NextImage from "../NextImage";
import { useRouter } from "next/router";

export default function RenderDelivery({ data }) {
  const { locale } = useRouter();

  return (
    <section className="p-3 mb-5 rounded-2xl border-[10px] border-[#f5f6fb]">
      <div className="flex flex-col-reverse items-start justify-between gap-8 p-6 bg-white rounded-2xl md:p-8 md:flex-row">
        <div className="space-y-6 md:w-2/3">
          <DeliveryHeader title={locale == 'en' ? data?.title : data?.title_ar} />

          {data?.list?.length
            ? data?.list?.map((item) => (
                <DeliveryInfoCard
                  key={item?.id}
                  locale={locale}
                  srcIcon={item?.icon}
                  title={locale == "en" ? item?.name : item?.name_ar}
                  type={item?.type}
                  items={item?.childrens}
                />
              ))
            : null}

          {Object.keys(data?.notes)?.length ? (
            <NoteCard
              title={
                locale == "en" ? data?.notes?.title : data?.notes?.title_ar
              }
              items={locale == "en" ? data?.notes?.list : data?.notes?.list_ar}
            />
          ) : null}
        </div>

        <div className="flex items-center justify-center w-full md:w-1/3 rounded-2xl">
          <div className="relative w-3/4 p-5">
          <NextImage
            src={data?.mainImg}
            alt="title"
            width={400}
            height={400}
            quality={100}
            priority
            className="object-contain w-full h-auto"
          />

          </div>
        </div>
      </div>
    </section>
  );
}
